// admin-panel/src/hooks/useAuth.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('dw_token');
    if (token) {
      authApi.me()
        .then(setUser)
        .catch(() => { localStorage.removeItem('dw_token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  async function login(email, password) {
    const res = await authApi.login({ email, password });
    localStorage.setItem('dw_token', res.token);
    setUser(res.user);
    return res;
  }

  async function logout() {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('dw_token');
    setUser(null);
    window.location.href = '/login';
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
